import { render, staticRenderFns } from "./UrlRestrictionType.vue?vue&type=template&id=7e8a0110&"
import script from "./UrlRestrictionType.vue?vue&type=script&lang=js&"
export * from "./UrlRestrictionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports